<template>
  <Modal class-name="vertical-center-modal" v-model="isBalance" title="设置余额提醒">
    <div class="form-wrapper">
      <Form :model="balanceForm" label-position="right" :label-width="100" :rules="ruleValidate">
        <FormItem label="金额低于">
          <div class="form-group">
            <Input type="number" style="width: 50%;" v-model="balanceForm.min_balance" placeholder="请输入大于等于0整数" />
            <span>元时发送提醒短信</span>
          </div>

        </FormItem>
        <FormItem label="接收手机">
          <div class="form-group">
            <Input v-model="balanceForm.sms_tip_mobile" placeholder="多个手机号用英文分号隔开;" />
          </div>
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="handelSubmit">确定</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import {
  Modal,
  Form,
  FormItem,
  Input
} from 'view-design'
import {
  setBalanceTip
} from '@/api/user'
import {
  accountIndex
} from '@/api/account'
import { matchInteger } from "@/utils/regExp";

export default {
  name: "BalanceTip",
  components: {
    Modal,
    Form,
    FormItem,
    Input
  },
  data: function () {
    return {
      isBalance: false,
      balanceForm: {
        min_balance: '',
        sms_tip_mobile: ''
      },
      loading: false,
      ruleValidate: {}
    }
  },
  methods: {
    init: function () {
      accountIndex().then(response => {
        this.balanceForm.min_balance = response.data.min_balance
        this.balanceForm.sms_tip_mobile = response.data.sms_tip_mobile
      }).catch(error => {
        console.log(error)
      })
      this.isBalance = true
    },
    handelCancel: function () {
      this.isBalance = false
    },
    handelSubmit: function () {
      if (this.loading) {
        return
      }
      // 为空提示
      if (this.balanceForm.min_balance==='') {
        this.$Message.error('金额请输入大于等于0的整数')
        return
      }
      // 非整数 （可输入0）
      if (!matchInteger.test(this.balanceForm.min_balance)) {
        this.$Message.error('金额请输入大于等于0的整数')
        return
      }
      // 超出最大范围99999

      if (this.balanceForm.min_balance>99999) {
        this.$Message.error('输入金额超出最大范围值:99999')
        return
      }


      this.loading = true
      setBalanceTip(this.balanceForm).then(response => {
        //console.log(response)
        this.loading = false
        this.$Message.success(response.message)
        this.handelCancel();
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
.normal-font {
  color: #ff8622;
  font-size: 14px;
}

>>>.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

>>>.vertical-center-modal .ivu-modal {
  top: 0;
}

>>>.form-wrapper .form-group .ivu-input:focus {
  border: 1px solid #ff8622 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 150, 43, 0.6) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 150, 43, 0.6) !important;
  outline: none;
}

>>>.form-wrapper .form-group .ivu-input:hover {
  border-color: #ff8622;
}

>>>.vertical-center-modal .ivu-modal-footer {
  border-top: none;
  padding: 12px 18px 12px 18px;
  text-align: right;
}

.footer-wrapper {
  display: flex;
  min-width: 0;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.footer-wrapper .btn {
  display: inline-block;
  border-radius: 4px;
  margin-right: 10px;
  padding: 0px 15px;
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.footer-wrapper .btn.confirm-btn {
  background: #ff8622;
  color: #fff;
}

.footer-wrapper .btn.cancel-btn {
  border: 1px solid #eeeeee;
  border-radius: 2px;
  color: #222222;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/account/modal/BalanceTip.vue